
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getPageTitle } from "@/utils/PageUtils";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CheckCircle, Clock, Home } from "lucide-react";
import StickyNavigation from "@/components/layout/StickyNavigation";
import TenantFooter from "@/components/layout/TenantFooter";

const QuoteSubmitted = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const aigQuote = (location.state as any)?.aigQuote;
  const pageTitle = "Quote Submitted Successfully!"

  useEffect(() => {
    document.title = getPageTitle(pageTitle);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      <StickyNavigation />
      <div className="py-12">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
        <Card className="text-center">
          <CardHeader className="pb-4">
            <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
              <CheckCircle className="h-8 w-8 text-green-600" />
            </div>
            <CardTitle className="text-2xl text-gray-900">
              {pageTitle}
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            {aigQuote && (aigQuote as any).ok ? (
              <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                <div className="flex items-center justify-center mb-2">
                  <CheckCircle className="h-5 w-5 text-green-600 mr-2" />
                  <span className="font-medium text-green-800">Your AIG quote is ready</span>
                </div>
                <p className="text-green-700 mb-2">
                  We've received a real-time quote from AIG for your SME package.
                </p>
                <p className="text-green-700 text-sm">
                  Quote reference: <span className="font-mono">{(aigQuote as any).quoteNumber ?? 'Pending from AIG'}</span>
                </p>
                {(aigQuote as any).premium && (
                  <p className="text-green-700 text-sm mt-2">
                    Estimated annual premium: <span className="font-semibold">AED {(aigQuote as any).premium}</span>
                  </p>
                )}
                <p className="text-green-700 text-xs mt-2">
                  Detailed premium breakdown is available to your broker in the admin dashboard.
                </p>
              </div>
            ) : (
              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <div className="flex items-center justify-center mb-2">
                  <Clock className="h-5 w-5 text-blue-600 mr-2" />
                  <span className="font-medium text-blue-800">What happens next?</span>
                </div>
                <p className="text-blue-700">
                  One of our insurance experts is reviewing your submission.
                  We'll come back to you within 24 hours with a personalized quote.
                </p>
              </div>
            )}

            <div className="text-gray-600">
              <p className="mb-4">
                Thank you for choosing our insurance services. We've received all your information
                and our team will carefully review your requirements to provide you with the best
                possible coverage options.
              </p>
              <p>
                If you have any urgent questions, please don't hesitate to contact us directly.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button onClick={() => {
                const m = window.location.pathname.match(/^(?:\/business)?\/site\/([^/]+)/);
                const prefix = m ? `/site/${m[1]}` : '';
                navigate(`${prefix}/`);
              }} className="flex items-center">
                <Home className="h-4 w-4 mr-2" />
                Return to Home
              </Button>
              <Button variant="outline" onClick={() => {
                const m = window.location.pathname.match(/^(?:\/business)?\/site\/([^/]+)/);
                const prefix = m ? `/site/${m[1]}` : '';
                navigate(`${prefix}/`);
              }}>
                Get Another Quote
              </Button>
            </div>
          </CardContent>
        </Card>
        </div>
      </div>
    </div>
  );
};

export default QuoteSubmitted;
